
export default {
  data: () => ({
    loaderRender: false,
    renderUrl: null,
    modalRender: false
  }),
  created () {
    this.$loadScript('/static/js/pdfobject.min.js')
  },
  methods: {
    renderDocument (store, resource = null, detail = 'pdf', id = this.$route.params.id) {
      this.modalRender = true
      if (this.renderUrl) {
        return false
      }
      this.loaderRender = true
      this.$store.dispatch(`${store}/RETRIEVE`, {
        resource: resource === null ? store : resource,
        detail: detail,
        id: id,
        setDetail: false,
        loader: false
      })
      .then((response) => {
        const byteCharacters = atob(response.data.file)
        const byteNumbers = new Array(byteCharacters)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new Blob([byteArray], {type: 'application/pdf'})
        this.renderUrl = URL.createObjectURL(file)
        this.$nextTick(() => {
          window.PDFObject.embed(this.renderUrl, '#render')
        })
      })
      .finally(() => {
        this.loaderRender = false
      })
    }
  }
}
